import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ICompany } from '@nxsys/types/models/company';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import { Form, Row, Col } from 'antd';
import { useImperativeHandle, Ref, useEffect, useState } from 'react';

type SafeRecSettingsFormRef = {
  submit: () => void;
};

export type SafeRecSettingsFormValues = {
  integratedCompanyId: string;
};

type SafeRecSettingsFormProps = {
  companyData?: ICompany;
  formRef?: Ref<SafeRecSettingsFormRef>;
  onSubmit?: (values: SafeRecSettingsFormValues) => void;
};

const SafeRecSettingsForm: React.FC<SafeRecSettingsFormProps> = ({
  companyData,
  formRef,
  onSubmit,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();
  const [needReinitializeForm, setNeedReinitializeForm] = useState(true);

  useImperativeHandle(formRef, () => ({
    submit: () => {
      form.submit();
    },
  }));

  const onFinish = (values: any) => {
    onSubmit?.(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  useEffect(() => {
    if (companyData?.safeRecSetting && needReinitializeForm) {
      const initialValues = {
        integratedCompanyId:
          companyData.safeRecSetting.integratedCompanyId || '',
      };
      form.setFieldsValue(initialValues);
      setNeedReinitializeForm(false);
    }
  }, [companyData?.safeRecSetting]);

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Row gutter={24}>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.companyId']}
            name="integratedCompanyId"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </AppFormContainer>
  );
};

export default SafeRecSettingsForm;
